module.exports = __webpack_public_path__ + "static/coolhouseranchthumb-60708f60ecfc795bfb40a878cfa39e24.jpg";